export default __webpack_public_path__ + "static/media/Vambraces of the Blood Drinker.89eceff5.jpg";